import { useEffect, useState } from "react";

import { firestoreService } from "utils/firebase";
import Model from "hooks/Model";
import { PostProps } from "models";

const BlogService = () => {
  const [currentPosts, setCurrentPosts] = useState<PostProps[]>([]);
  const [loading, setLoading] = useState(true);

  const getPosts = async () => {
    const posts = [];
    (await firestoreService.getCollection("posts")).forEach((incomeData) => {
      posts.push({ ...incomeData.data(), id: incomeData.id });
    });

    setCurrentPosts(posts.sort((a, b) => b.created - a.created));
  };

  const firstLoad = async () => {
    try {
      setLoading(true);

      await getPosts();
    } catch (error) {
      Model.updateAlerts({
        message: error?.message || error,
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const refetch = async () => {
    await firstLoad();
  };

  useEffect(() => {
    firstLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    recentPosts: currentPosts.slice(0, 3),
    currentPosts,
    loading,
    refetch,
  };
};

export default BlogService;
